import axios from '@/axios'

class HeadquartersDataService {
  async getAllHeadquarters(page: number): Promise<any> {
    return axios.get(`/headquarters/getAllHeadquarters?page=${page}`)
  }
  async getAllVirtualHeadquarters(): Promise<any> {
    return axios.get('/headquarters/getAllVirtualHeadquarters')
  }
  async getHeadquartersById(id: any): Promise<any> {
    return axios.get(`/headquarters/${id}/get`)
  }
  async add(data: any): Promise<any> {
    return axios.post('/headquarters/add', data)
  }
  async uploadImage(id:any, data: any): Promise<any> {
    const formData = new FormData()
    formData.append('image', data)
    return axios.post(`/headquarters/${id}/uploadImage`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
  async update(id: any, data: any): Promise<any> {
    return axios.put(`/headquarters/${id}/update`, data)
  }
  async delete(id: any): Promise<any> {
    return axios.delete(`/headquarters/${id}/delete`)
  }
  async getHeadquartersTypes(): Promise<any> {
    return axios.get('/headquarters/getHeadquartersTypes')
  }
  private static buildVhqOverviewParams(
    page: number,
    search: string,
    packageFilter: string,
    status: string,
    companyType: string,
    dateFrom: string,
    dateTo: string,
    exportMode: boolean
  ): URLSearchParams {
    const params = new URLSearchParams({ page: String(page) })
    if (exportMode) params.set('export', '1')
    if (search) params.append('search', search)
    if (packageFilter) params.append('package', packageFilter)
    if (status) params.append('status', status)
    if (companyType) params.append('company_type', companyType)
    if (dateFrom) params.append('date_from', dateFrom)
    if (dateTo) params.append('date_to', dateTo)
    return params
  }

  async getVhqOverview(page = 1, search = '', packageFilter = '', status = '', companyType = '', dateFrom = '', dateTo = ''): Promise<any> {
    const params = HeadquartersDataService.buildVhqOverviewParams(page, search, packageFilter, status, companyType, dateFrom, dateTo, false)
    return axios.get(`/headquarters/getVhqOverview?${params.toString()}`)
  }

  async getVhqExport(search = '', packageFilter = '', status = '', companyType = '', dateFrom = '', dateTo = ''): Promise<any> {
    const params = HeadquartersDataService.buildVhqOverviewParams(1, search, packageFilter, status, companyType, dateFrom, dateTo, true)
    return axios.get(`/headquarters/getVhqOverview?${params.toString()}`)
  }

  // Admin VHQ Management endpoints
  async getAdminVhqList(): Promise<any> {
    return axios.get('/vhq-management/getAllVhq')
  }
  async updateVhqOrder(vhqIds: number[]): Promise<any> {
    return axios.put('/vhq-management/update-order', { vhq_ids: vhqIds })
  }
}
export default new HeadquartersDataService()
